import React from 'react';
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {HorizontalLoader, InfiniteScroll, Loader, ScrollableCard} from "@mc/mc-legacy";
import ListItemFixed from "./ListItemFixed";
import {withRouter} from "react-router";
import "./ItemListFixed.scss";
import MessageEmptyList from "./MessageEmptyList";

const ItemListFixed = (props) => {
    let {itemList, renderItem, emptyList, className} = props;

    if (!itemList.fetched) {
        return <Loader key="fixed-loader"/>;
    }

    if (itemList.count === 0) {
        return emptyList;
    }

    return (
        <ScrollableCard key="scroll-card" detail className="inverse item-list-fixed h-100">
            <InfiniteScroll
                className={className ? className : "items-box"}
                bordered
                loadMore={() => props.dispatch(props.loadMore())}
                hasMore={itemList.hasMore}
            >
                {itemList.isFetching && <HorizontalLoader key={'loader'} hover/>}
                {itemList.rows.map((item, detail) => {
                    return (
                        <div key={item.id}>
                            <ListItemFixed>{renderItem(item)}</ListItemFixed>
                        </div>
                    );
                })}
            </InfiniteScroll>
        </ScrollableCard>
    );
};

ItemListFixed.propTypes = {
    itemList: PropTypes.object,
    //store listu
    loadMore: PropTypes.func.isRequired,
    renderItem: PropTypes.func.isRequired,
    emptyList: PropTypes.object,
    className: PropTypes.string,
};
ItemListFixed.defaultProps = {
    emptyList: <MessageEmptyList/>,
};

function mapStateToProps(state, props) {
    return {};
}

export default connect(mapStateToProps)(withRouter(ItemListFixed));
